import { Info } from 'components'

import * as S from './styles'

export interface SectionCardProps {
  title: string
  tooltip?: boolean
  tooltipText?: string
  optional?: boolean
  children: React.ReactNode
}

export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  tooltip = true,
  tooltipText,
  optional = false,
  children,
}) => {
  return (
    <S.Wrapper>
      <S.TitleRow>
        <span>
          <strong>{title}</strong> {optional && '(opcional)'}
        </span>

        {tooltip && !!tooltipText && <Info iconSize={13}>{tooltipText}</Info>}
      </S.TitleRow>
      <S.Content>{children}</S.Content>
    </S.Wrapper>
  )
}
